var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 5,
    viewBox: "0 0 17 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11759",
    "data-name": "Rectangle 11759",
    width: 17,
    height: 5,
    rx: 2.5,
    fill: "#ff1400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribed);
export default __webpack_public_path__ + "static/media/Unsubscribed.2ddafa160d2d79294b53589d4be523e3.svg";
export { ForwardRef as ReactComponent };